var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyDataActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22871 10.5234V12.2268",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13867 12.2507H11.3198",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.151 1.75H4.3073C3.33901 1.75 2.5542 2.53342 2.5542 3.5V3.5C2.5542 4.46658 3.33901 5.25 4.3073 5.25H10.151C11.1193 5.25 11.9041 4.46658 11.9041 3.5V3.5C11.9041 2.53342 11.1193 1.75 10.151 1.75Z",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.151 7H4.3073C3.33901 7 2.5542 7.78342 2.5542 8.75V8.75C2.5542 9.71658 3.33901 10.5 4.3073 10.5H10.151C11.1193 10.5 11.9041 9.71658 11.9041 8.75V8.75C11.9041 7.78342 11.1193 7 10.151 7Z",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.229 3.50065H10.1508",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32749 3.48003C4.3389 3.49142 4.3389 3.50988 4.32749 3.52128C4.31608 3.53267 4.29758 3.53267 4.28617 3.52128C4.27476 3.50988 4.27476 3.49142 4.28617 3.48003C4.29758 3.46864 4.31608 3.46864 4.32749 3.48003",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.229 8.75065H10.1508",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32749 8.73003C4.3389 8.74142 4.3389 8.75988 4.32749 8.77127C4.31608 8.78267 4.29758 8.78267 4.28617 8.77127C4.27476 8.75988 4.27476 8.74142 4.28617 8.73003C4.29758 8.71864 4.31608 8.71864 4.32749 8.73003",
    stroke: "#20E290",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDataActive);
export default __webpack_public_path__ + "static/media/company_data_active.a29eb87d4d28a70a5b05664b6dbad1d6.svg";
export { ForwardRef as ReactComponent };